// Aparición al scroll (spec §11.8/§15.3): fade + 24px + blur, una sola vez.
export function initReveal() {
	const elements = document.querySelectorAll("[data-reveal]");
	if (!elements.length) return;

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		elements.forEach((el) => el.classList.add("is-visible"));
		return;
	}

	const observer = new IntersectionObserver(
		(entries) => {
			for (const entry of entries) {
				if (!entry.isIntersecting) continue;
				entry.target.classList.add("is-visible");
				observer.unobserve(entry.target);
			}
		},
		{ threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
	);

	elements.forEach((el) => {
		// Lo que ya está en pantalla se muestra de inmediato; el observador
		// solo vigila lo que queda por debajo del pliegue.
		const rect = el.getBoundingClientRect();
		if (rect.top < window.innerHeight && rect.bottom > 0) {
			el.classList.add("is-visible");
		} else {
			observer.observe(el);
		}
	});

	// Red de seguridad: si el layout se asienta tarde (fuentes, imágenes) el
	// observador puede perderse un elemento y dejaría contenido invisible.
	const sweep = () => {
		document.querySelectorAll("[data-reveal]:not(.is-visible)").forEach((el) => {
			const rect = el.getBoundingClientRect();
			if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) {
				el.classList.add("is-visible");
			}
		});
	};
	window.addEventListener("scroll", sweep, { passive: true });
	window.addEventListener("load", sweep);
}
